import { useRequireAuth } from '@/hooks/use-require-auth'
import { ClientLoyalty } from './profile/loyalty/client-loyalty'

export function LoyaltyPage() {
  useRequireAuth()

  return <ClientLoyalty />
}
